import { Fragment } from 'react';
import {
  Button,
  Icon,
  IconEnum,
  R1H1,
  logoBg,
} from '@greenkub-fronts/shared/ui';

import styles from './signature-success.module.scss';

export interface SignatureSuccessProps {
  documentObjectURL: string | undefined;
}

export function SignatureSuccess(props: SignatureSuccessProps) {
  const { documentObjectURL } = props;

  return (
    <div
      className={styles['SignatureSuccess']}
      style={{ backgroundImage: `url(${logoBg})` }}
    >
      {!documentObjectURL ? (
        <R1H1>
          <span>Votre document est en cours de préparation</span>
        </R1H1>
      ) : (
        <Fragment>
          <Icon
            name={IconEnum.CONFETTI}
            className={styles['SignatureSuccess-confetti']}
            width="80"
          />
          <R1H1>
            <span>Tout est prêt ! Votre document est prêt</span>
          </R1H1>
          <a target="_blank" rel="noreferrer" href={documentObjectURL}>
            <Button label="Télécharger le PDF" />
          </a>
        </Fragment>
      )}
    </div>
  );
}

export default SignatureSuccess;
